import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart';
import Service from './service';
import AreaSplineChartWithHeader from './../../component/areaSplineChartWithHeader';
import Utils from './../../component/utils/utils';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false,
        selectedInterval: 60,
    }

    componentDidMount () {
        Service.fetchPackageInventory(60);

        Service.event.onFetchPackageInventory.add((data) => {
            console.log("*** data");

            console.log(data);

            this.setState({
                renderChart : true,
                responseTableData: data,
                histogramChartCategoriesList: data.chartData.categoryList,
                histogramChartSeriesDataList1: data.chartData.seriesDataList1
            });
        });


    }

    componentWillUnmount() {

    }

    constructor() {
        super();
        // setting default attribute values
        this.intervalOptions = Utils.intervalOptions;
    }

    selectElementChange = (event) => {
        this.setState({ selectedInterval: event.target.value});
        Service.fetchPackageInventory(event.target.value);
    };

    // refresh button actions
    searchButtonAction = () => {
        Service.fetchPackageInventory(this.state.selectedInterval);
    };

    render() {
        return (
            <div>
                <div className="graph-width">
                    { this.state.renderChart ? <AreaSplineChartWithHeader
                        chartTitle = {"Package Inventory for " + this.state.selectedInterval + " days"}
                        histogramChartCategoriesList = {this.state.histogramChartCategoriesList}
                        histogramChartSeriesDataList = {
                            [{name : "Package Inventory",
                                data : this.state.histogramChartSeriesDataList1
                            }]
                        }
                        selectElementChange = {this.selectElementChange}
                        searchButtonAction = {this.searchButtonAction}
                        selectDropdownValues = {this.intervalOptions}
                        yAxisTitle = "Package Inventory"
                        headerIconClass = "fa fa-credit-card"
                    /> : '' }
                </div>
            </div>
        );
    }
}

export default ChartView;